// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ReportCardSlider_sliderContainer__5SwCF","slider":"ReportCardSlider_slider__FDo2L","navButton":"ReportCardSlider_navButton__ZB6li"};